import { render } from "./TableTariffeEe.vue?vue&type=template&id=1e06529e"
import script from "./TableTariffeEe.vue?vue&type=script&lang=js"
export * from "./TableTariffeEe.vue?vue&type=script&lang=js"

import "./TableTariffeEe.vue?vue&type=style&index=0&id=1e06529e&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__